// eslint-disable-next-line import/prefer-default-export
export const NEW_ITEM_ROUTE = 'new';
